export default __webpack_public_path__ + "static/media/policy13_2023.3e8c14db.jpg";